import React from 'react';

const TrustSection = () => {
  return (
    <section className="py-8 sm:py-12 md:py-16 bg-gradient-to-br from-amber-50 via-white to-amber-50">
      <div className="container mx-auto px-3 sm:px-4">
        <div className="text-center mb-6 sm:mb-8 md:mb-10">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-gray-900 mb-2 sm:mb-3">
            Why <span className="text-amber-600">1,000+ Customers</span> Trust Jatin Interior
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-gray-600">
            Proven excellence backed by premium interior design and exceptional craftsmanship
          </p>
        </div>
        
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 md:gap-6 mb-6 sm:mb-8">
          {/* Years Experience */}
          <div className="card p-4 sm:p-5 md:p-6 text-center group hover:shadow-2xl transition-all duration-300 bg-white rounded-2xl border border-amber-200 shadow-lg">
            <div className="mx-auto flex h-14 w-14 sm:h-16 sm:w-16 md:h-20 md:w-20 items-center justify-center rounded-full mb-3 sm:mb-4 transition-transform duration-300 group-hover:scale-110 bg-gradient-to-br from-amber-500 to-amber-600">
              <span className="material-symbols-outlined text-white text-xl sm:text-2xl md:text-3xl">workspace_premium</span>
            </div>
            <p className="text-3xl sm:text-4xl md:text-5xl font-extrabold mb-2 text-amber-600">15+</p>
            <p className="text-sm sm:text-base font-bold text-gray-900 mb-1">Years Experience</p>
            <p className="text-xs sm:text-sm text-gray-500">In Interior Design</p>
          </div>
          
          {/* Customer Satisfaction */}
          <div className="card p-4 sm:p-5 md:p-6 text-center group hover:shadow-2xl transition-all duration-300 bg-white rounded-2xl border border-amber-200 shadow-lg">
            <div className="relative mx-auto flex h-14 w-14 sm:h-16 sm:w-16 md:h-20 md:w-20 items-center justify-center mb-3 sm:mb-4">
              <div className="h-full w-full transform transition-transform duration-300 group-hover:rotate-180 relative">
                <svg className="w-full h-full transform -rotate-90" viewBox="0 0 36 36">
                  <path
                    className="text-gray-200"
                    stroke="currentColor"
                    strokeWidth="3"
                    fill="none"
                    d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                  />
                  <path
                    className="text-amber-500"
                    stroke="currentColor"
                    strokeWidth="3"
                    strokeDasharray="95, 100"
                    fill="none"
                    d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                  />
                </svg>
                <span className="absolute inset-0 flex items-center justify-center text-lg sm:text-xl font-extrabold text-amber-600">95%</span>
              </div>
            </div>
            <p className="text-3xl sm:text-4xl md:text-5xl font-extrabold mb-2 text-amber-600">95%</p>
            <p className="text-sm sm:text-base font-bold text-gray-900 mb-1">Customer Satisfaction</p>
            <p className="text-xs sm:text-sm text-gray-500">Design success rate</p>
          </div>
          
          {/* Happy Customers */}
          <div className="card p-4 sm:p-5 md:p-6 text-center group hover:shadow-2xl transition-all duration-300 bg-white rounded-2xl border border-amber-200 shadow-lg">
            <div className="mx-auto flex h-14 w-14 sm:h-16 sm:w-16 md:h-20 md:w-20 items-center justify-center rounded-full mb-3 sm:mb-4 transition-transform duration-300 group-hover:scale-110 bg-gradient-to-br from-amber-500 to-amber-600">
              <span className="material-symbols-outlined text-white text-xl sm:text-2xl md:text-3xl">groups</span>
            </div>
            <p className="text-3xl sm:text-4xl md:text-5xl font-extrabold mb-2 text-amber-600">1,000+</p>
            <p className="text-sm sm:text-base font-bold text-gray-900 mb-1">Happy Customers</p>
            <div className="flex justify-center items-center gap-0.5 mb-1">
              {[1, 2, 3, 4, 5].map((star) => (
                <span key={star} className="material-symbols-outlined text-yellow-400 text-sm">star</span>
              ))}
            </div>
            <p className="text-xs sm:text-sm text-gray-500">Across India</p>
          </div>
          
          {/* Quality Certified */}
          <div className="card p-4 sm:p-5 md:p-6 text-center group hover:shadow-2xl transition-all duration-300 bg-white rounded-2xl border border-amber-200 shadow-lg">
            <div className="mx-auto flex h-14 w-14 sm:h-16 sm:w-16 md:h-20 md:w-20 items-center justify-center rounded-full mb-3 sm:mb-4 transition-transform duration-300 group-hover:scale-110 bg-gradient-to-br from-amber-500 to-amber-600">
              <span className="material-symbols-outlined text-white text-xl sm:text-2xl md:text-3xl">verified</span>
            </div>
            <p className="text-xl sm:text-2xl md:text-3xl font-extrabold mb-2 text-amber-600">ISO Certified</p>
            <p className="text-sm sm:text-base font-bold text-gray-900 mb-1">Quality Assured</p>
            <p className="text-xs sm:text-sm text-gray-500 font-semibold mb-2">Trusted Brand</p>
            <div className="flex justify-center items-center gap-1">
              <span className="material-symbols-outlined text-green-600 text-sm">check_circle</span>
              <span className="text-xs text-gray-600">Premium Materials</span>
            </div>
          </div>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
          <div className="flex items-center gap-3 rounded-2xl border-2 border-amber-200 bg-white p-3 sm:p-4 transition-all hover:border-amber-500 hover:shadow-xl">
            <span className="material-symbols-outlined text-green-600 shrink-0 text-xl">eco</span>
            <h3 className="text-sm sm:text-base font-bold text-gray-800">Eco-Friendly Materials</h3>
          </div>
          
          <div className="flex items-center gap-3 rounded-2xl border-2 border-amber-200 bg-white p-3 sm:p-4 transition-all hover:border-amber-500 hover:shadow-xl">
            <span className="material-symbols-outlined text-amber-600 shrink-0 text-xl">shield</span>
            <h3 className="text-sm sm:text-base font-bold text-gray-800">5 Year Warranty</h3>
          </div>
          
          <div className="flex items-center gap-3 rounded-2xl border-2 border-amber-200 bg-white p-3 sm:p-4 transition-all hover:border-amber-500 hover:shadow-xl">
            <span className="material-symbols-outlined text-amber-600 shrink-0 text-xl">favorite</span>
            <h3 className="text-sm sm:text-base font-bold text-gray-800">Trusted Nationwide</h3>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustSection;
